export const location = {
  countries: 'locationEndpoint/getCountries',
  cities: 'locationEndpoint/v2/getCities',
  citiesV1: 'locationEndpoint/getCities',
  stores: 'locationEndpoint/getAllStores',
  supportNumbers: 'locationEndpoint/getSupportNumbers',
  deliveryTypeText: 'algoliaEndpoint/getDeliveryTimeLabelConfig',
  autocomplete: 'locationEndpoint/autoCompleteDirections',
  activeCities: 'locationEndpoint/getActiveCities',
  nearbyStores: 'route/r/CO/v1/stores/nearby'
};
